import { FormControl } from '@angular/forms';
import { activeTranslations } from '../../../../../enum/constants';
import { liveObject } from '../../../../../core/i18n';


export interface GroupForm {
  name: FormControl;
  x_data: any;
}

export interface Permission {
  id: string,
  name: string,
  key: string,
  type: string
}

export interface GroupPermission {
  id: string,
  group_id: string,
  permission_id: string,
}

export const PERMISSIONS_KEYS = {
  ACCESS_CHANNELS: 'access_channels',
  ACCESS_CHATS: 'access_chats',
  DISTRIBUTE_CHATS: 'distribute_chats',
};

// Мапа лише читається (`PERMISSIONS[key]` у шаблоні), тож її можна перебудовувати
// на зміну мови. liveObject зберігає стабільне посилання, а значення віддає живі.
export const PERMISSIONS: any = liveObject(() => ({
  'access_team': activeTranslations.permissions.access_team,
  'action_team': activeTranslations.permissions.action_team,
  'access_change_own_role': activeTranslations.permissions.access_change_own_role,
  'access_apps': activeTranslations.permissions.access_apps,
  'action_apps': activeTranslations.permissions.action_apps,
  'access_integration': activeTranslations.permissions.access_integration,
  'cash_register_operations': activeTranslations.permissions.cash_register_operations,
  'action_integration': activeTranslations.permissions.action_integration,
  'access_crm': activeTranslations.permissions.access_crm,
  'action_crm': activeTranslations.permissions.action_crm,
  'access_contacts': activeTranslations.permissions.access_contacts,
  'action_contacts': activeTranslations.permissions.action_contacts,
  'access_logistics': activeTranslations.permissions.access_logistics,
  'action_logistics': activeTranslations.permissions.action_logistics,
  'access_company': activeTranslations.permissions.access_company,
  'action_company': activeTranslations.permissions.action_company,
  'access_payment': activeTranslations.permissions.access_payment,
  'action_payment': activeTranslations.permissions.action_payment,
  'access_change_own_channel_groups': activeTranslations.permissions.access_change_own_channel_groups,
  'access_channels': activeTranslations.permissions.access_channels,
  'action_channels': activeTranslations.permissions.action_channels,
  'access_p_channels': activeTranslations.permissions.access_p_channels,
  'action_p_channels': activeTranslations.permissions.action_p_channels,
  'access_settings': activeTranslations.permissions.access_settings,
  'action_settings': activeTranslations.permissions.action_settings,
  'access_files': activeTranslations.permissions.access_files,
  'action_files': activeTranslations.permissions.action_files,
  'access_automation': activeTranslations.permissions.access_automation,
  'action_automation': activeTranslations.permissions.action_automation,
  'access_chats': activeTranslations.permissions.access_chats,
  'distribute_chats': activeTranslations.permissions.distribute_chats,
  'action_chats': activeTranslations.permissions.action_chats,
}));
